import './CardCommon.css';

export default function CardMeterGrid({ data, onClick }) {
    const getMeterIcon = (data) => {
        const value = data?.connection_logger;
        if (value === undefined || value === null) {
            return <h5 className="card-title font-weight-bold mb-0"> Grid Meter </h5>
        }

        if (data.connection_logger === true) {
            if (data.connection_device === true) {
                return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm normal'>Online</span></h5>
            }
            return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm alarming'>Device Offline</span></h5>
        }
        return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm alarming'>Logger Offline</span></h5>
    }

    const ReadTags = (data, digit) => {
        const value = data;
        if (value === undefined || value === null) {
            return "-"
        }
        return data.toFixed(digit)
    }

    const ReadTags_Thounsand = (data, digit) => {
        const value = data;
        if (value === undefined || value === null) {
            return "-"
        }
        return data.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    const ReadTags_String = (data) => {
        const value = data;
        if (value === undefined || value === null) {
            return "Update : -"
        }
        return "Update : " + data
    }

    const ReadTags_SubSystem = (data) => {
        const value = data?.subsystem_name;
        if (value === undefined || value === null) {
            return null
        }
        if (data.subsystem_name !== "") {
            return <h6 className="mt-0 mb-0">Subsystem : {data.subsystem_name}</h6>
        }
        return null
    }

    const ReadTags_SerialNo = (data) => {
        const value = data?.serial_no;
        if (value === undefined || value === null) {
            return null
        }
        if (data.serial_no !== undefined) {
            return <h6 className="mt-0 mb-0">Serial No. : {data.serial_no}</h6>
        }
        return null
    }

    const ReadTags_MeterAreaName = (data) => {
        const value = data?.meter_area_name;
        if (value === undefined || value === null) {
            return null
        }
        if (data.meter_area_name !== "") {
            return <p className="update-time mt-0 mb-0 text-info">Location : {data.meter_area_name}</p>
        }
        return null
    }

    return (
        <div className="card-meter-wrapper-out">
            <div className="card-meter-wrapper">
                <div className="card card-common card-meter shadow-none">
                    <div className="card-body d-flex flex-row pt-1 pb-1 inverter-header px-1 ">
                        <div className='d-block'>
                            <div className="d-flex mt-0 mb-0">
                                {getMeterIcon(data)}
                            </div>
                            {ReadTags_SerialNo(data)}
                            <p className="update-time mt-0 mb-0">{ReadTags_String(data.update_time)}</p>
                        </div>
                    </div>

                    <div className="card-body pb-2 pt-0 pr-0 px-1" onClick={() => onClick({
                        type: 'Grid Meter',
                        meter_id: 'Grid Meter',
                        datakey: 'grid_active',
                        data: data
                    })}>
                        <div className="row">
                            <div className="col-md-12 mb-0">
                                <div >
                                    <div className="measure-table font-poppins">
                                        <div className="measure-rows font-bold measure-header">
                                            <div className="measure-cell border-bottom px-2">Parameter</div>
                                            <div className="measure-cell numberright border-bottom">Value</div>
                                            <div className="measure-cell measunits border-bottom">Unit</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Voltage L1</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.voltage_l1, 3)}</div>
                                            <div className="measure-cell measunits">Volt</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Voltage L2</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.voltage_l2, 3)}</div>
                                            <div className="measure-cell measunits">Volt</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Voltage L3</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.voltage_l3, 3)}</div>
                                            <div className="measure-cell measunits">Volt</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Voltage L12</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.voltage_l12, 3)}</div>
                                            <div className="measure-cell measunits">Volt</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Voltage L23</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.voltage_l23, 3)}</div>
                                            <div className="measure-cell measunits">Volt</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Voltage L31</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.voltage_l31, 3)}</div>
                                            <div className="measure-cell measunits">Volt</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Current L1</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.current_l1, 3)}</div>
                                            <div className="measure-cell measunits">A.</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Current L2</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.current_l2, 3)}</div>
                                            <div className="measure-cell measunits">A.</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell border-bottom px-2">Current L3</div>
                                            <div className="measure-cell border-bottom numberright font-sarabun">{ReadTags_Thounsand(data.current_l3, 3)}</div>
                                            <div className="measure-cell border-bottom measunits">A.</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Power Factor</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags(data.power_factor, 3)}</div>
                                            <div className="measure-cell measunits"></div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Active Power</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.power_active_total, 3)}</div>
                                            <div className="measure-cell measunits">kW</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Active Power L1</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.power_active_l1, 3)}</div>
                                            <div className="measure-cell measunits">kW</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Active Power L2</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.power_active_l2, 3)}</div>
                                            <div className="measure-cell measunits">kW</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Active Power L3</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.power_active_l3, 3)}</div>
                                            <div className="measure-cell measunits">kW</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Apparent Power</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.power_apparent_total, 3)}</div>
                                            <div className="measure-cell measunits">kVA</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell border-bottom px-2">Reactive Power</div>
                                            <div className="measure-cell border-bottom numberright font-sarabun">{ReadTags_Thounsand(data.power_reactive_total, 3)}</div>
                                            <div className="measure-cell border-bottom measunits">kVAr</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Energy Active Total Export</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_active_total_export, 3)}</div>
                                            <div className="measure-cell measunits">kWh</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Energy Reactive Total Export</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_reactive_total_export, 3)}</div>
                                            <div className="measure-cell measunits">kVArh</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Energy Active Total Import</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_active_total_import, 3)}</div>
                                            <div className="measure-cell measunits">kWh</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Energy Reactive Total Import</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_reactive_total_import, 3)}</div>
                                            <div className="measure-cell measunits">kVArh</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell px-2">Energy Active Total</div>
                                            <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_active_total, 3)}</div>
                                            <div className="measure-cell measunits">kWh</div>
                                        </div>
                                        <div className="measure-rows">
                                            <div className="measure-cell border-bottom px-2">Energy Reactive Total</div>
                                            <div className="measure-cell border-bottom numberright font-sarabun">{ReadTags_Thounsand(data.energy_reactive_total, 3)}</div>
                                            <div className="measure-cell border-bottom measunits">kVArh</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <p className='see-more mt-1 mb-0'>Click to see power chart.</p>
            </div>
        </div>
    )
}

